import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { neenahConfig } from "./data";

export default function NeenahPage() {
  return <CityPageTemplate config={neenahConfig} />;
}